import type { Directive } from "vue";

// 滚动入场指令：元素进入视口时淡入上浮。
// 用法：
//   v-reveal            // 默认动画
//   v-reveal="120"      // 延迟 120ms（用于同排多个块的错位入场）
interface RevealEl extends HTMLElement {
  _revealObserver?: IntersectionObserver;
}

const reveal: Directive<RevealEl, number | undefined> = {
  mounted(el, binding) {
    el.classList.add("reveal");

    const delay = binding.value;
    if (typeof delay === "number") {
      el.style.transitionDelay = `${delay}ms`;
    }

    // 尊重系统的“减少动态效果”偏好
    const reduce = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduce) {
      el.classList.add("reveal-visible");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("reveal-visible");
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    observer.observe(el);
    el._revealObserver = observer;
  },
  unmounted(el) {
    el._revealObserver?.disconnect();
  },
};

export default reveal;
